import { Preference } from './../model/preference';
import { ModalPartageComponent } from './../modals/modal-partage/modal-partage.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { PreferenceMessages } from '../../../shared/models/component-messages/preference-messages';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-partage-preference',
  templateUrl: './partage-preference.component.html',
  styleUrls: ['./partage-preference.component.scss']
})
export class PartagePreferenceComponent implements OnInit, OnDestroy {

  constructor(private modalService: NgbModal) { }

  public preferenceMessages = new PreferenceMessages();

  private unsubscribe$ = new Subject<void>();

  @Input() id: number;
  @Input() isAcheteur: boolean = false;

  @Output() preferenceCopied: EventEmitter<Preference> = new EventEmitter();

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  clickPartage(): void {
    const modalRef = this.modalService.open(ModalPartageComponent);
    if (this.id !== undefined) {
      modalRef.componentInstance.mode = 1;
      modalRef.componentInstance.id = this.id;
    } else {
      modalRef.componentInstance.mode = 2;
      modalRef.componentInstance.preferenceCopied
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: (data: Preference) => {
            this.preferenceCopied.emit(data);
          }
        });
    }
  }

}
